export const pagesInitialState = {
  error: "",
  loading: false,
  data: {
    industries: [],
    countries: [],
    paymentMethods: [],
  },
};
